import React, { Component, useState } from "react";
import { render } from "react-dom";
import AdminHome from "./AdminHomeMobile";
import AdminHomeD from "./AdminHomeDesktop";
import { useMediaQuery } from 'react-responsive'


export default function AdminHomeResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        <AdminHomeD/>
      </div>
    )
}

